import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { User } from '@innersight-os/shared/firestore-interfaces';
import { of, ReplaySubject } from 'rxjs';
import { getDownloadURL, ref, Storage } from '@angular/fire/storage';
import { switchMap } from 'rxjs/operators';
import { UserWithPhoto } from '@innersight-os/shared/firebase-services';

@Component({
    selector: 'is-avatar',
    templateUrl: './avatar.component.html',
    styleUrls: ['./avatar.component.sass'],
    standalone: false
})
export class AvatarComponent implements OnChanges {
  @Input() user: User | UserWithPhoto;
  @Input() size: 'small' | 'normal' = 'normal'

  private user$ = new ReplaySubject<User>(1);

  photoURL$ = this.user$.pipe(
    switchMap(user => {
      if(!user) return of(null)

      const {photoPath, photoURL} = user as UserWithPhoto
      if(photoURL) return of(photoURL)
      if(photoPath) return getDownloadURL(ref(this.storage, photoPath))

      return of(null)
    })
  )

  constructor(private storage: Storage) {}

  ngOnChanges({user}: SimpleChanges) {
    if(user) this.user$.next(user.currentValue)
  }

  get initials() {
    if(!this.user.displayName) return '?'

    const initials = (this.user.displayName).split(' ').map(name => name[0])

    return initials.length === 1
      ? initials[0] || ''
      : initials[0] + initials.pop()
  }
}
